<template>
    <div>
        <el-form
			ref="resetPwdForm"
			:rules="resetPwdRule"
			:model="resetPwdData"
			label-position="left"
			label-width="100px">
			<p class="formTitle">找回密码</p>
			<el-form-item
				label="验证方式"
				prop="loginName"
				style="width:100%">
				<el-select
					v-model="resetPwdData.veriMode"
					style="width:100%">
					<el-option
						v-for="item in verificateModeList"
						:key="item.value"
						:label="item.label"
						:value="item.value"/>
				</el-select>
			</el-form-item>
			<el-form-item
				v-if="'cellphone' === resetPwdData.veriMode"
				label="手机号码"
				prop="phone"
				style="width:100%">
				<el-input
					v-model="resetPwdData.phone"
					clearable
					placeholder="请输入手机号码"
					style="width:50%" />
				<el-button
					type="primary"
					style="width:45%; margin-left: 5%"
					:loading="phoneVeriCodeNextTime > 0"
					@click="onLoginGetPhoneVeriCodeBtnClk">
					{{ phoneVeriCodeNextTime > 0 ? '(' + phoneVeriCodeNextTime + ')' : '获取验证码' }}
				</el-button>
			</el-form-item>
			<el-form-item
				v-else-if="'email' === resetPwdData.veriMode"
				label="邮箱地址"
				prop="email"
				style="width:100%">
				<el-input
					v-model="resetPwdData.email"
					clearable
					placeholder="请输入邮箱地址"
					style="width:50%" />
				<el-button
					type="primary"
					style="width:45%; margin-left: 5%"
					:loading="emailVeriCodeNextTime > 0"
					@click="onResetPwdGetEmailVeriCodeBtnClk">
					{{ emailVeriCodeNextTime > 0 ? '(' + emailVeriCodeNextTime + ')' : '获取验证码' }}
				</el-button>
			</el-form-item>
			<el-form-item
				label="验证码"
				prop="veriCode"
				style="width:100%">
				<el-input
					v-model="resetPwdData.veriCode"
					clearable
					placeholder="请输入验证码"
					style="width:100%" />
			</el-form-item>
			<el-form-item
				label="密码"
				prop="password1"
				style="width:100%">
				<el-input
					v-model="resetPwdData.password1"
					show-password
					clearable
					placeholder="请输入密码"
					style="width:100%" />
			</el-form-item>
			<el-form-item
				label="重复密码"
				prop="password2"
				style="width:100%">
				<el-input
					v-model="resetPwdData.password2"
					show-password
					clearable
					placeholder="请重复密码"
					style="width:100%" />
			</el-form-item>
		</el-form>
		<el-row style="margin-top: 20px; margin-bottom: 20px;">
			<el-button
				type="text"
				style="margin-left: 50px; float: right;"
				@click="onBackToLoginBtnClk">
				返回登录
			</el-button>
		</el-row>
		<el-row>
			<el-button
				class="loginButton"
				@click="onResetPwdToBackendBtnClk"
				type="primary">
				重置密码
			</el-button>
		</el-row>
    </div>
</template>

<script>
import { sha256 } from 'js-sha256'
import {
    getResetPwdVeriCodeByEmail,
    resetPasswordByVeriCode
} from "@/api/webResetPwd.js"
export default {
    name: 'ResetPwd',

    mounted() {
        this.resetPwdData = {
            veriMode: 'cellphone',
            phone: '',
            email: '',
            veriCode: '',
            password1: '',
            password2: '',
        };
        this.timerHandle = setInterval(() => {
            if (this.phoneVeriCodeNextTime > 0) {
                this.phoneVeriCodeNextTime -= 1; // 如果手机验证码的时间不是0，那么手机验证码的剩余时间-1s
            }
            if (this.emailVeriCodeNextTime > 0) {
                this.emailVeriCodeNextTime -= 1; // 如果邮箱验证码的时间不是0，那么邮箱验证码的剩余时间-1s
            }
        }, 1000)
    },

    beforeRouteLeave() {
        clearInterval(this.timerHandle);
    },

    data() {
        var that = this;
        return {
            timerHandle: null,
            verificateModeList: [{
                value: 'cellphone',
                label: '手机验证',
            }, {
                value: 'email',
                label: '邮箱验证',
            }],

            // 重置密码的数据
            resetPwdData: {
                veriMode: 'cellphone',
                phone: '',
                email: '',
                veriCode: '',
                password1: '',
                password2: '',
            },

            // 重置密码formdata的规则
            resetPwdRule: {
                veriMode: [{
                    required: true,
                    message: "验证模式不能为空",
                    trigger: "blur"
                }],

                phone: [{
                    required: true,
                    validator: (rule, value, callback) => {
                        if ((null == value) || ('' == value)) {
                            return callback(new Error("手机号不能为空"));
                        }

                        var myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
                        if(!myreg.test(value)) {
                            return callback(new Error("手机号码格式非法"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                }],

                email: [{
                    required: true,
                    validator: (rule, value, callback) => {
                        if ((null == value) || ('' == value)) {
                            return callback(new Error("邮箱地址不能为空"));
                        }

                        if (value.match(/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/)) {
                            callback();
                        } else {
                            callback(new Error("邮箱地址格式不对"))
                        }
                    },

                    trigger: "blur"
                }],

                veriCode: [{
                    required: true,
                    message: "验证码不能为空",
                    trigger: "blur"
                }],

                password1: [{
                    required: true,
                    message: "密码不能为空",
                    trigger: "blur"
                }],

                password2: [{
                    required: true,
                    validator: (rule, value, callback ) => {
                        if ((null == value) || ('' == value)) {
                            return callback(new Error("请再次输入密码"));
                        }

                        if (that.resetPwdData.password1 != that.resetPwdData.password2) {
                            return callback(new Error("两次输入的密码不一致"));
                        }

                        callback();
                    },
                    trigger: "blur" 
                }]
            },

            phoneVeriCodeNextTime: 0, // 手机验证码剩余时间
            emailVeriCodeNextTime: 0, // 邮箱验证码剩余时间
        }
    },

    methods: {
        onLoginGetPhoneVeriCodeBtnClk() {
            // 获取手机验证码
            // this.phoneVeriCodeNextTime = 120;
            this.$message({
                message: "暂时不支持手机验证功能",
                type: "error",
                duration: 3 * 1000
            })
        },

        onResetPwdGetEmailVeriCodeBtnClk() {
            // 获取忘记密码的验证码
            this.$refs['resetPwdForm'].validateField('email', valid => {
                if ('' !== valid) {
                    return;
                }

                getResetPwdVeriCodeByEmail(this.resetPwdData.email).then((res) => {
                    this.$message({
                        message: res.data,
                        type: "success",
                        duration: 3 * 1000
                    })
                    // 如果邮箱格式合法，更新定时
                    this.emailVeriCodeNextTime = 120;
                }, (error) => {
                    this.$message({
                        message: error,
                        type: "error",
                        duration: 3 * 1000
                    })
                    this.resetPwdData.password1 = '';
                    this.resetPwdData.password2 = '';
                    this.resetPwdData.password = undefined;
                })
            });
        },

        onBackToLoginBtnClk() {
            this.$emit('modeChanged', 'login');
        },

        onResetPwdToBackendBtnClk() {
            this.$refs["resetPwdForm"].validate(valid => {
                if (!valid) {
                    this.resetPwdData.password1 = "";
                    this.resetPwdData.password2 = "";
                    return;
                }
            })
                
            this.resetPwdData.password = sha256(this.resetPwdData.password1);
            resetPasswordByVeriCode(this.resetPwdData).then((res) => {
                this.$message({
                    message: '成功',
                    type: "success",
                    duration: 3 * 1000
                })
                this.phoneVeriCodeNextTime = 0;
                this.emailVeriCodeNextTime = 0;
                this.mode = "login";
                this.$refs["resetPwdForm"].resetFields();
                this.resetPwdData = {
                    veriMode: 'cellphone',
                    phone: '',
                    email: '',
                    veriCode: '',
                    password1: '',
                    password2: '',
                };
            }, (error) => {
                this.resetPwdData.password1 = '';
                this.resetPwdData.password2 = '';
                this.$message({
                    message: error,
                    type: "error",
                    duration: 3 * 1000
                })
            })
        }
    }
}
</script>

<style lang="less" scoped>
.loginButton {
    float: middle;
    width: 80%;
    margin-left: 10%;
    height: 50px;
    border-radius: 25px;
    font-size: 15pt;
}
</style>